import { FindAllQueueRecordsStore } from '../../../../application/store/queue-records/index';
import React from 'react';
export const MakeFindAllQueueRecordsStore = () => {
  return new FindAllQueueRecordsStore();
};
